import Vue from 'vue';
import axios from 'axios';
import VueAxios from 'vue-axios';
// MD Icons: https://materialdesignicons.com/
import '@mdi/font/css/materialdesignicons.min.css';
import VueOwinAuth from '@codehq/vue-owin-auth/src/vueOwinAuth';
import { VueMaskDirective } from 'v-mask';
import { o } from 'odata';
import { mapState } from 'vuex';
import NewDocumentList from '@codehq/prickles-client-documents-expenses/src/components/NewDocumentList.vue';
import ProcessedDocumentList from '@codehq/prickles-client-documents-expenses/src/components/ProcessedDocumentList.vue';
import VuetifyConfirm from 'vuetify-confirm';
import vJsonEditor from 'v-jsoneditor';
import App from './App.vue';
import authHub from './authHub';
import DatePicker from './components/DatePicker.vue';
import PdfViewer from './components/PdfViewer.vue';
import ViewDocument from './components/ViewDocument.vue';
import ExportToExcelButton from './components/ExportToExcelButton.vue';
import ViewDoc from './components/ViewDoc.vue';
import VNumeric from '~libs/vuetify-numeric.umd';
import vuetify from './plugins/vuetify';
import store from './store';
import router from './router';

Vue.config.productionTip = false;

Vue.use(VueOwinAuth, {
  url: process.env.VUE_APP_APIURL,
});

Vue.use(VueAxios, axios);

Vue.use(VNumeric);

Vue.use(VuetifyConfirm, { vuetify });

Vue.use(vJsonEditor);

// Setup shared custom components
Vue.component(DatePicker.name, DatePicker);
Vue.component(NewDocumentList.name, NewDocumentList);
Vue.component(PdfViewer.name, PdfViewer);
Vue.component(ProcessedDocumentList.name, ProcessedDocumentList);
Vue.component(ViewDocument.name, ViewDocument);
Vue.component(ViewDoc.name, ViewDoc);
Vue.component(ExportToExcelButton.name, ExportToExcelButton);

Vue.directive('mask', VueMaskDirective);

// Setup API
axios.defaults.baseURL = process.env.VUE_APP_APIURL;
o(process.env.VUE_APP_APIURL);

// format
Vue.mixin({
  methods: {
    formatRoundCurrency(n) {
      const result = parseFloat((Math.round(n * 100) / 100).toFixed(2));
      console.log(result);
      return result;
    },
  },
});

new Vue({
  vuetify,
  store,
  router,
  computed: {
    ...mapState('app', ['token']),
  },
  created() {
    axios.interceptors.request.use((config) => {
      // eslint-disable-next-line no-param-reassign
      config.headers.common.Authorization = `Bearer ${this.token}`;
      return config;
    }, (error) => Promise.reject(error));
    axios.interceptors.response.use((response) => response, (error) => {
      if (error.response.status === 401) {
        authHub.$emit('user.unauthorized');
      }
      return Promise.reject(error);
    });
  },
  render: (h) => h(App),
}).$mount('#app');
